import i18n from 'config/i18n';
import { isEmpty, isNil } from 'ramda';

import { Arrangement, TravelCompensationType } from './types';

import { getLocale } from 'utils/date';

import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';

const t = i18n.getFixedT(getLocale());

type Props = {
  hasTravelMovementsFeature?: boolean;
};

export const useColumnDefinitions = ({ hasTravelMovementsFeature }: Props) => [
  {
    field: 'code',
    headerName: t('adminPortal.arrangements.code'),
    hideable: false,
    flex: 1
  },
  {
    field: 'codeExtern',
    headerName: t('adminPortal.arrangements.externalCode'),
    flex: 1
  },
  {
    field: 'description',
    headerName: t('adminPortal.arrangements.description'),
    flex: 1
  },
  {
    field: 'arrangementType',
    headerName: t('adminPortal.arrangements.typeOfArrangement'),
    flex: 1
  },
  ...(hasTravelMovementsFeature
    ? [
        {
          field: 'transportationMode',
          headerName: t('travelDistances.transportationMode'),
          valueFormatter: (params) =>
            params?.value
              ? t(`travelDistances.transportationModes.${params.value}`)
              : '',
          flex: 1
        }
      ]
    : []),
  {
    field: 'isExternal',
    headerName: t('adminPortal.arrangements.isExternal'),
    flex: 1,
    renderCell: BooleanCell
  }
];

const converterForArrangementType = (
  arrangementTypes: TravelCompensationType[],
  currentId: number
) => arrangementTypes.find((item) => item.id === currentId)?.name ?? '';

export const convertResponseForArrangementType = (
  response: Arrangement[] | undefined,
  arrangementTypes: TravelCompensationType[] | []
) =>
  response
    ? response.map((data) => {
        return {
          ...data,
          arrangementType: converterForArrangementType(
            arrangementTypes,
            data.compensationTypeId
          )
        };
      })
    : [];

export const convertArrangementTypeToOption = (
  arrangementTypes: TravelCompensationType[]
): Option[] => {
  if (!isNil(arrangementTypes) || !isEmpty(arrangementTypes)) {
    return arrangementTypes?.map((type) => ({
      value: type.id,
      label: type.description
    }));
  } else return [];
};
